/*
 * 4-Б1 «Филиал: шаг сетки и режим заполнения». По листу — колонка 640: это настройка,
 * которую читают перед выбором, а не таблица, которую просматривают.
 */

.screen {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  height: 100%;
  min-height: 0;
  padding: var(--space-4);
  overflow: auto;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 640px;
  padding: 14px 16px;
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.skeletons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 640px;
}

.block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid var(--grid-line-minor);
}

/* Черта отделяет блок от предыдущего. У первого блока карточки предыдущего нет,
   и черта вплотную под рамкой карточки читалась как пустая строка сверху. */
.column > .block:first-child {
  padding-top: 0;
  border-top: 0;
}

.blockTitle {
  font-weight: var(--font-weight-semibold);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Последствие выбранного шага — главный текст экрана, а не подпись под кнопками. */
.consequence {
  margin: 0;
  color: var(--text-secondary);
}

.warning {
  padding: 9px 12px;
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 8px;
}

.modes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.mode,
.modeActive {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
}

.modeActive {
  border: 1.5px solid var(--accent);
}

.mode:disabled,
.modeActive:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.modeTitle {
  font-weight: var(--font-weight-semibold);
}

.modeText {
  font-size: 12px;
  color: var(--text-secondary);
}

/*
 * Конфликт версий показывает ОБА значения и два действия: «оставить моё» и «взять
 * текущее». Владелец решает, чьё значение остаётся, и решить это он может только видя
 * оба — «обновите страницу» отправляет его начинать сначала и терять свою правку.
 */
.conflict {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  color: var(--note-fg);
  background: var(--note-bg);
  border: 1px solid var(--note-border);
  border-radius: 8px;
}

.conflictButtons {
  display: flex;
  gap: 6px;
}

.hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-secondary);
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.saved {
  font-size: var(--font-size-sm);
  color: var(--info-fg);
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid var(--grid-line-minor);
}

/* Журнал открытий телефона: строка на сотрудника, числа справа. */
.reveals {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.revealRow {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  justify-content: space-between;
}
